/**
 * Application constants and enum values
 */

export const COUNTRIES = [
  'United States',
  'Canada',
  'Ireland',
  'Scotland',
  'Japan',
  'India',
  'Mexico'
];

export const BOTTLE_TYPES = [
  'Bourbon',
  'Whiskey',
  'American Single Malt',
  'Rye',
  'Scotch',
  'Irish',
  'Japanese',
  'Canadian',
  'Brandy'
];

export const BOTTLE_STATUSES = [
  'Ordered',
  'Unopened',
  'Opened',
  'Empty'
];

export const BOTTLE_SIZES = [
  '50ml',
  '100ml',
  '200ml',
  '350ml',
  '375ml',
  '700ml',
  '750ml',
  '1L',
  '1.5L',
  '1.75L'
];

/**
 * Purchase price buckets used by the Dashboard's Price distribution chart.
 * Ranges are [min, max) except the last, open-ended bucket.
 * Must mirror the CASE thresholds in supabase/migrations/005_add_bottles_by_price_range.sql
 */
export const PRICE_RANGES = [
  { label: 'Under $25', min: 0, max: 25 },
  { label: '$25 - $49', min: 25, max: 50 },
  { label: '$50 - $99', min: 50, max: 100 },
  { label: '$100 - $149', min: 100, max: 150 },
  { label: '$150 - $249', min: 150, max: 250 },
  { label: '$250+', min: 250, max: null }
];

export const PAGE_SIZE_OPTIONS = [20, 50, 100, 'All'];

export const DEFAULT_PAGE_SIZE = 20;

export const SORT_DIRECTIONS = {
  ASC: 'asc',
  DESC: 'desc'
};
